module.exports = __webpack_public_path__ + "static/media/manoela-nunes.9ba982a2.jpeg";